<mat-card class="layer-card" appearance="outlined">
  <mat-card-header>
    <mat-card-title-group class="layer-header">
      <mat-card-title>
        <mat-checkbox
          [checked]="layer.isSelected"
          (change)="uploadedLayersService.actionLayer('shared', layer)"
          [disabled]="uploadedLayersService.layersLoading$()[layer.id]"
        >
          {{ layer.name }}
        </mat-checkbox>
      </mat-card-title>
      @if (uploadedLayersService.layersLoading$()[layer.id]) {
        <mat-spinner [diameter]="20"></mat-spinner>
      }
    </mat-card-title-group>
  </mat-card-header>

  @if (layer.isSelected || layer.displayError) {
    <mat-card-content class="mat-card-content">
      <div class="mat-card-info">
        <div>
          <p>
            @if (layer.displayError) {
              <span class="no-data"> This layer could not be displayed. </span>
            } @else if (!layer.sizeState || layer.sizeState.status === 'loading') {
              <mat-spinner [diameter]="20"></mat-spinner>
            } @else if (layer.sizeState.status === 'error') {
              <span class="no-data">Error loading this layer</span>
            } @else {
              Size: {{ layer.sizeState.data }}
            }
          </p>

          <p>Shared by {{ layer.owner_email }}</p>
        </div>

        <div class="mat-card-buttons">
          @if (!layer.displayError) {
            <button
              matIconButton
              aria-label="Center map on data"
              matTooltip="Center map on data"
              (click)="uploadedLayersService.uploadedLayerCenterMap(layer)"
            >
              <mat-icon>gps_fixed</mat-icon>
            </button>
          }
          <button
            matIconButton
            aria-label="Remove shared layer from my account"
            matTooltip="Remove shared layer from my account"
            (click)="deleteLayerWithConfirm(layer)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
      @if (!layer.displayError) {
        <div class="mat-card-symbology">
          <img
            src="{{ imageUrl }}{{ layer.layer_type }}"
            onerror="this.style.visibility = 'hidden'"
          />
        </div>
      }
    </mat-card-content>
  }
</mat-card>
